// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__f4kme {
  align-items: center;
  color: #18316e;
  display: flex;
  max-height: 84vh;
  justify-content: center;
  width: 99vw;
}

.styles_box__LkQQJ {
  background: white;
  border-radius: 10px;
  box-shadow: 2px 2px 5px #505050;
  padding: 1rem 3rem 2rem 3rem;
  text-align: center;
  width: 50vw;
}

.styles_title__vE59g {
  font-size: 1.5rem;
  font-weight: bold;
}

.styles_img__iHz7F {
    border-radius: 5px;
    width: 70%;
    margin-top: 1rem;
}

.styles_body__RBTp1 {
    font-size: 1.1rem;
    margin: 1rem 0;
}

@media (max-width: 500px){
  .styles_title__vE59g {
    font-size: 1.2rem;
  }
  .styles_body__RBTp1{
    font-size: .9rem;
    margin: 1rem 0 .5rem 0;
  }

  .styles_box__LkQQJ{
    padding: 1rem;
  }
}
@media (max-width: 769px){
  .styles_box__LkQQJ{
    width: 70vw;
  }
}
@media (min-width: 1550px){
  .styles_box__LkQQJ{
    width: 25vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AguardandoAssinatura/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  max-height: 84vh;\n  justify-content: center;\n  width: 99vw;\n}\n\n.box {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 2px 2px 5px #505050;\n  padding: 1rem 3rem 2rem 3rem;\n  text-align: center;\n  width: 50vw;\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.img {\n    border-radius: 5px;\n    width: 70%;\n    margin-top: 1rem;\n}\n\n.body {\n    font-size: 1.1rem;\n    margin: 1rem 0;\n}\n\n@media (max-width: 500px){\n  .title {\n    font-size: 1.2rem;\n  }\n  .body{\n    font-size: .9rem;\n    margin: 1rem 0 .5rem 0;\n  }\n\n  .box{\n    padding: 1rem;\n  }\n}\n@media (max-width: 769px){\n  .box{\n    width: 70vw;\n  }\n}\n@media (min-width: 1550px){\n  .box{\n    width: 25vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__f4kme`,
	"box": `styles_box__LkQQJ`,
	"title": `styles_title__vE59g`,
	"img": `styles_img__iHz7F`,
	"body": `styles_body__RBTp1`
};
export default ___CSS_LOADER_EXPORT___;
